import cex from '~/exportReport/template/converted/cex_alt.rt.yml';
import { type MapSettingsDataAction } from '../../data/mapSettingsData.action';
import { type ExportReportToolStateAction } from './exportReportToolState.action';
import {
  exportReportDisable, exportReportEnable, exportReportSetTemplate,
} from './exportReportToolState.actionCreators';
import { type ExportReportToolState } from './exportReportToolState.state';

export const mapSettingsExportReportInitialState: ExportReportToolState = {
  isActive: false,
  template: cex,
  params: null,
};

export const exportReportToolStateReducer = (
  state = mapSettingsExportReportInitialState,
  action: ExportReportToolStateAction | MapSettingsDataAction
): ExportReportToolState => {
  if (exportReportEnable.match(action)) {
    return {
      ...state,
      isActive: true,
      params: action.payload.params,
    };
  }

  if (exportReportDisable.match(action)) {
    return {
      ...state,
      isActive: false,
      params: null,
    };
  }

  if (exportReportSetTemplate.match(action)) {
    return {
      ...state,
      template: action.payload.template,
    };
  }

  return state;
};
